import { type ReactNode } from 'react';

import { TOP_NAV_DATA_TEST } from '@/app/components/layouts/top-navigation/tracking';
import type { MenuLinkType, NavItemType } from '@/app/types/top-navigation';
import type { VehicleType } from '@/app/types/vehicle-type';
import { TopNavigation } from '@/components/layouts/top-navigation';
import { BuyingTools } from '@/components/layouts/top-navigation/buying-tools';
import { TopNavigationStyled } from '@/components/layouts/top-navigation/styles';

interface TopNavigationFilledProps {
  Logo: ReactNode;
  vehicleType: VehicleType;
  items: NavItemType[];
  buyingTools: MenuLinkType[];
}

export const TopNavigationFilled = ({
  Logo,
  vehicleType = 'lcv',
  items = [],
  buyingTools = [],
}: TopNavigationFilledProps) => {
  return (
    <>
      <BuyingTools items={buyingTools} vehicleType={vehicleType} />
      <TopNavigationStyled
        variant="filled"
        data-test={TOP_NAV_DATA_TEST.header}
      >
        <TopNavigation
          Logo={Logo}
          items={items}
          vehicleType={vehicleType}
          variant="filled"
        />
      </TopNavigationStyled>
    </>
  );
};
